import { ReactComponent as CloseBlue } from 'assets/icons/closeSharpBlue.svg'
import { ReactComponent as Close } from 'assets/icons/closeSharpWhite.svg'
import classNames from 'classnames'
import { useIsAuth } from 'feature/auth/hooks'
import { UserData } from 'feature/user/components'
import { isLkmDomain } from 'router/utils'
import { useAppSelector } from 'store/hooks'
import { Link, MenuBlock } from 'ui'
import { LoaderInCentalPosition } from 'widget'

import { LkMenuItems } from './config/LkMenuItems'
import { LkmMenuItems } from './config/LkmMenuItems'
import style from './Menu.module.scss'
import { NotificationIndicator } from './NotificationIndicator'
import { useGetUserData } from 'feature/user/hooks/useGetUserData'

export type TMenu = {
  handleChange: (open: boolean) => void
}

// боковое меню
export function Menu({ handleChange }: TMenu) {
  const isAuth = useIsAuth()
  const isLkm = isLkmDomain()

  const { data, isFetching, isRegularUser } = useGetUserData()

  const hasUnreadNotifications = useAppSelector(
    state => state.auth.userInfo.hasUnreadNotifications,
  )

  const menuList = !isLkm ? LkMenuItems : LkmMenuItems

  return (
    <section className={classNames(style.menu)}>
      <button
        type='button'
        className={style.menuCloseBtn}
        onClick={() => handleChange(false)}
      >
        <Close />
      </button>
      <div className={style.menuContainer}>
        <div
          className={classNames(
            style.menuHeader,
            'tablet-hidden',
            'desktop-hidden',
            'mt24 mb24',
          )}
        >
          <Link href='/'>
            <img src='/images/logo-header.svg' alt='DoorHan logo' />
          </Link>
          <button type='button' onClick={() => handleChange(false)}>
            <CloseBlue />
          </button>
        </div>
        {isAuth && (
          <div className={style.menuInfBlock}>
            {isFetching && <LoaderInCentalPosition className={style.loader} />}
            {data && !isFetching && (
              <>
                <UserData className={style.kek} data={data} />
                {isRegularUser && (
                  <NotificationIndicator
                    isNotification={hasUnreadNotifications}
                    handleClick={() => handleChange(false)}
                  />
                )}
              </>
            )}
          </div>
        )}

        <div className={style.menuItems}>
          {menuList.map(item => (
            <MenuBlock
              key={item.link}
              Icon={item.Icon}
              link={item.link}
              text={item.text}
              className={style.menuButton}
              handleClick={() => handleChange(false)}
            />
          ))}
        </div>
      </div>
    </section>
  )
}
